"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PromoControlsWrapper = require("./PromoControlsWrapper");
Object.keys(_PromoControlsWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PromoControlsWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PromoControlsWrapper[key];
    }
  });
});